import { useLoyaltyStore } from '../loyaltyStore'
import { translateCrmCodes } from './translateCrmCodes'

export const prefillFormFields = field => {
  const {
    accessToken,
    salutation,
    title,
    firstName,
    lastName,
    streetAndHouseNumber,
    addressAddition,
    postCode,
    city,
    country,
    email,
    loyaltyAccountId
  } = useLoyaltyStore(state => ({
    accessToken: state.accessToken,
    salutation: state.personalInput?.crmAttributes?.salutation,
    title: state.personalInput?.crmAttributes?.title,
    firstName: state.personalInput?.crmAttributes?.firstName,
    lastName: state.personalInput?.crmAttributes?.lastName,
    streetAndHouseNumber:
      state.personalInput?.crmAttributes?.streetAndHouseNumber,
    addressAddition: state.personalInput?.crmAttributes?.addressAddition,
    postCode: state.personalInput?.crmAttributes?.postCode,
    city: state.personalInput?.crmAttributes?.city,
    country: state.personalInput?.crmAttributes?.country,
    email: state.personalInput?.crmAttributes?.email,
    loyaltyAccountId: state.personalInput?.loyaltyAccount?.loyaltyAccountId
  }))

  let storedValue = ''
  if (accessToken) {
    switch (field.fieldType) {
      case 'salutation':
        storedValue = translateCrmCodes('salutation', salutation)
        break
      case 'title':
        storedValue = translateCrmCodes('title', title)
        break
      case 'firstName':
        storedValue = firstName
        break
      case 'lastName':
        storedValue = lastName
        break
      case 'street':
        storedValue = streetAndHouseNumber
        break
      case 'addressAddition':
        storedValue = addressAddition
        break
      case 'city':
        storedValue = city
        break
      case 'country':
        storedValue = country
        break
      case 'zipcode':
        storedValue = postCode
        break
      case 'emailAddress':
        storedValue = email
        break
      case 'cardNumber':
        storedValue = loyaltyAccountId
        break

      default:
        storedValue = ''
    }
  }
  return storedValue
}
